// @ts-nocheck
/* eslint-disable */
/**
 * Generated by orval v8.13.0 🍺
 * Do not edit manually.
 * SUREnet crm-public API
 * OpenAPI spec version: 1
 */
import { useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { unref } from 'vue';
import type { MaybeRef } from 'vue';

import type { AdresGetAdresParams } from '../model/adresGetAdresParams';

import type { Result1OfCrmAdressenZoekEnMaakAdresAdresMetToevoegingen } from '../model/result1OfCrmAdressenZoekEnMaakAdresAdresMetToevoegingen';

import { customInstance } from '../../customInstance';
import type { ErrorType } from '../../customInstance';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const adresGetAdres = (
  params?: MaybeRef<AdresGetAdresParams>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customInstance<Result1OfCrmAdressenZoekEnMaakAdresAdresMetToevoegingen>(
    { url: `/api/v1/adres`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getAdresGetAdresQueryKey = (params?: MaybeRef<AdresGetAdresParams>) => {
  return ['api', 'v1', 'adres', ...(params ? [params] : [])] as const;
};

export const getAdresGetAdresQueryOptions = <
  TData = Awaited<ReturnType<typeof adresGetAdres>>,
  TError = ErrorType<void>,
>(
  params?: MaybeRef<AdresGetAdresParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adresGetAdres>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getAdresGetAdresQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adresGetAdres>>> = ({ signal }) =>
    adresGetAdres(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adresGetAdres>>,
    TError,
    TData
  >;
};

export type AdresGetAdresQueryResult = NonNullable<Awaited<ReturnType<typeof adresGetAdres>>>;
export type AdresGetAdresQueryError = ErrorType<void>;

export function useAdresGetAdres<
  TData = Awaited<ReturnType<typeof adresGetAdres>>,
  TError = ErrorType<void>,
>(
  params?: MaybeRef<AdresGetAdresParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adresGetAdres>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAdresGetAdresQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}
